import { Location } from "@angular/common";
import { Component, OnInit, ViewChild } from "@angular/core";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { ActivatedRoute, ParamMap, Router } from "@angular/router";
import { DataSharingService } from "src/app/AuthGuard/DataSharingService";
import { EncrDecrService } from "src/app/AuthGuard/EncrDecrService";
import { constantUrl } from "src/app/Shared/constantUrl";
import { DialogService } from "src/app/Shared/dialog.service";
import { SnackbarComponent } from "src/app/snackbar/snackbar.component";
import { QuickLoanService } from "../../_QuickLoan/services/quickLoan.service";
import { LmsService } from "../services/lms.service";
import { MasterService } from "../../Shared/app.Masters.Service";
import { LosService } from "../../_LOS/services/los.service";
import { MatPaginator } from "@angular/material/paginator";


declare var $: any;
@Component({
    selector: "app-lms-loan-precloser-new-details",
    templateUrl: "./lms-loan-precloser-new-details.component.html",
    styleUrls: ["./lms-loan-precloser-new-details.component.scss"],
    standalone: false
})
export class LmsLoanPrecloserNewDetailsComponent implements OnInit {
  EmployeeProfileBaseUrl: any = constantUrl.apiProfilePicUrl;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  data: any;
  LoanId: any;
  showSpinner: boolean = false;
  closerId: any;
  LoanTenureFreq: any = "Months";
  MinEffectiveDate = new Date();
  LoanAllDetail: any = [];
  LoanAllDetailNew: any = [];
  LoanCustomerList: any = [];
  dataSource: any;
  displayedColumns: string[] = [];
  CustomerName: any = "";
  CustomerAddress: any = "";
  _prevDate: any;
  isCheckedCustomer: boolean = true;
  displayedUnaccoutedColumns: any = null
  XIRR: any;
  PreCloserDetails: any = {
    LoanCloser_EffectiveDate: new Date(),
    CloserType: "",
  };
  isMaker: string = "";
  PreCloserMethodList: any = [];
  PrintCloserMethodList: any = [];
  totalCalculator: any = {
    totalDueAmount: 0,
    totalReceiveAmount: 0,
    totalWaiverAmount: 0,
    totalBalance: 0,
  };
  printtotalCalculator: any = {
    totalDueAmount: 0,
    totalReceiveAmount: 0,
    totalWaiverAmount: 0,
    totalBalance: 0,
  };

  loandocBaseUrl: any = constantUrl.LoanDocUrl;
  AllowExtension: any = constantUrl.AllowExtension;
  RequestDocName: any = "";
  RequestDocBase64: any = "";
  LoanChargesRecoverableList: any;
  LoanChargesRecoverable_Balance: any = 0;
  LoanChargesRecoverable: any = { Due_Amount: 0, Received_Amount: 0 };
  isShowForward: boolean = false;
  wavieruserList: any[] = [];
  today: Date = new Date();
  loanSummary: any = {};
  isExpired: boolean = false;
  isMyCloserRequest: boolean = false;
  voucherModel: any = { Voucher: {}, Voucher_Detail: [] };
  isWavierGivenByMe: boolean = false;
  isUndoRemark: boolean = false;
  undoRemark: any = "";
  loanStatement: any;
  displayedColumnsModelForLoanCloser: any;
  accountName_Not_Bind: any = "";
  CompanyLogo: any;
  Waiver_Account_Id: any = 0;
  Voucher_Date = new Date();
  voucherCustomerName: string = '';
  voucherLoanAcNo: string = '';
  chargesHeadDropdown: any[] = [];
  chargesHeadProductIdLoaded: any = 0;
  Bind_Voucher: number = 1;
  loading: boolean = false;
  taxSlabList: any[] = [];
  stateDropdownList: any[] = [];
  taxSlabModel: any = {};
  dataSourceUnaccouted: any = null
  activeVoucherRowIndex: number = -1;
  InterMediatAccountId: any = 0
  Loan_Acc_Type: any = "";
  displayedColumnsPreCloser: string[] = [
    'netReceivable',
    'amountToDeposit',
    'waiverUser',
    'waiverRequired',
    'closerXirr',
    'uploadDoc',
    'preCloserRemark',
    'waiverRemark',
    'loanCloserInfo',
    'actions'
  ];
  preCloserDataSource: any[] = [];
  configSuccess: MatSnackBarConfig = {
    panelClass: "style-success",
    duration: 5000,
    horizontalPosition: "right",
    verticalPosition: "top",
  };

  @ViewChild(MatSort, { static: true }) sort: MatSort;
  minDate: Date;
  CalculatedXirr: any;
  Target_IRR: any;
  RequiredNextEmi: any;
  constructor(
    private dataSharingService: DataSharingService,
    private _EncrDecrService: EncrDecrService,
    private snackBar: MatSnackBar,
    private router: Router,
    private dialog: DialogService,
    private route: ActivatedRoute,
    private lmsService: LmsService,
    private location: Location,
    private _QuickLoanService: QuickLoanService,
    private _MasterService: MasterService,
    private losService: LosService
  ) {
    this.data = JSON.parse(sessionStorage.getItem("currentUser"));
    console.log(this.data);
    this.route.paramMap.subscribe((param: ParamMap) => {
      this.LoanId = this._EncrDecrService.decrypt(
        decodeURIComponent(param.get("loanId"))
      );
      this.closerId = this._EncrDecrService.decrypt(
        decodeURIComponent(param.get("closerId"))
      );
      this.isMaker = param.get("isMaker");

      this.getLoanRescheduleDetail();
    });
    sessionStorage.removeItem("LoanSummary");
  }

  ngOnInit() {
    this.dataSharingService.HeaderTitle.next("Loan Pre Closure Details");
    this.displayedColumns = [
      "Int_Id",
      "CustomerId",
      "Customer",
      "CustomerType",
      "GenderAge",
      "PhoneNo",
      "Relation_With_Hirer",
      "Present_Address",
      "ExistingCustomer",
    ];

    this.CompanyLogo = this.data.CompanyLogo;
    this.GetStateDropdown();
    this.Get_TaxSlab_Dropdown();
  }

  onEffectiveDateChange() {
    if (!this._prevDate || !this.PreCloserDetails.LoanCloser_EffectiveDate) {
      return;
    }
    if (
      this._prevDate.toLocaleDateString("fr-CA") !=
      new Date(
        this.PreCloserDetails.LoanCloser_EffectiveDate
      ).toLocaleDateString("fr-CA")
    ) {
      this.LMS_Get_Loan_Closer_Due_Detail(
        new Date(
          this.PreCloserDetails.LoanCloser_EffectiveDate
        ).toLocaleDateString("fr-CA")
      );
    }


    if (new Date(this.PreCloserDetails.LoanCloser_EffectiveDate) <
      new Date(
        this.PreCloserDetails.lastTrasactionDate
          ?.split("-")
          .reverse()
          .join("-") + " 00:00:00"
      )
    ) {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "You are not allowed to close the loan before last transaction date!!",
        ...this.configSuccess,
      });
    }
  }

  LMS_Get_Loan_Closer_Due_Detail(date: any) {
    this.showSpinner = true;
    this.accountName_Not_Bind = '';
    this.lmsService
      .LMS_Get_Loan_Closer_Due_Detail_New({
        Loan_Id: JSON.parse(this.LoanId),
        LoginUserId: this.data.userId,
        EffictiveDate: date,
        LoanCloserId: JSON.parse(this.closerId),
        IsIntermediate: this.isCheckedCustomer ? 1 : 0
      })
      .subscribe((res: any) => {
        if (res != null) {
          let _data = res.Item1[0] || {};
          this.Waiver_Account_Id =
            _data.Waiver_Account_Id == null ? 0 : _data.Waiver_Account_Id;
          _data.LoanCloser_EffectiveDate = new Date(
            _data.LoanCloser_EffectiveDate
          );
          _data.NextDueDate = new Date(_data.NextDueDate);
          this._prevDate = _data.LoanCloser_EffectiveDate;
          _data.CloserType =
            _data.CloserType == "" || _data.CloserType == null
              ? this.PreCloserDetails.CloserType
              : _data.CloserType;
          this.PreCloserDetails = _data;
          this.Loan_Acc_Type = _data.Loan_Acc_Type;

          this.PreCloserMethodList = res.Item2 ? res.Item2 : [];
          this.PrintCloserMethodList = res.Item2 ? res.Item2 : [];
          var headName = "";
          this.PreCloserMethodList.map((item) => {
            item.newBalance =
              item.Balance < 0 ? item.Balance * -1 : item.Balance;
            if (!this.isCheckedCustomer && item.HeadId > 0 &&
              (item.AccountHeadId == null ||
                item.AccountHeadId == "" ||
                item.AccountHeadId == 0) &&
              item.ChagesHead != null
            ) {
              headName = item.ChagesHead;
              if (item.HeadId == 5) {
                headName = "Broken Period Interest";
              }
              this.accountName_Not_Bind =
                this.accountName_Not_Bind + headName + ",";
            }
          });
          this.PreCloserDetails.Waiver_GivenBy =
            this.PreCloserDetails.Waiver_GivenBy;
          if (
            this.PreCloserDetails.Closer_RequestStatus != "Closed" &&
            new Date().toLocaleDateString("fr-CA") !=
            new Date(
              this.PreCloserDetails.LoanCloser_EffectiveDate
            ).toLocaleDateString("fr-CA")
          ) {
            this.isExpired =
              this.PreCloserDetails.LoanCloser_EffectiveDate.getTime() <
              this.MinEffectiveDate.getTime();
          }
          this.isMyCloserRequest =
            (this.PreCloserDetails.LoanCloser_RequestBy || "").toString() ==
            this.data.userId.toString();
          this.isWavierGivenByMe =
            (this.PreCloserDetails.Waiver_GivenBy || "").toString() ==
            this.data.userId.toString();
          this.onCalculateAmount();
          this.onPrintCalculateAmount();

          //this.lmsService
          //  .ACC_Get_ChargesHead_Amount_Details({
          //    LoanId: JSON.parse(this.LoanId),
          //    ChargeHeadId: 35,
          //  })
          //  .subscribe((result: any) => {
          //    if (result.Item1.length > 0) {
          //      this.LoanChargesRecoverableList = result.Item1;
          //      this.LoanChargesRecoverable = result.Item2[0];
          //      this.LoanChargesRecoverable_Balance =
          //        result.Item2[0].Due_Amount - result.Item2[0].Received_Amount;
          //    }
          //  });
          this.LoanChargesRecoverableList = res.Item3;
          this.LoanChargesRecoverable = res.Item4[0];
          this.LoanChargesRecoverable_Balance =
            res.Item4[0].Due_Amount - res.Item4[0].Received_Amount;
          // }
          // });
          // this.CalculateXirr();
          if (this.PreCloserDetails.Closer_RequestStatus == "Closed") {
            this.CalculatedXirr = _data.Closed_Xirr;
          } else {
            this.CalculateXirr();
          }
          this.PreCloserDetails = res.PreCloserDetails || this.PreCloserDetails;
          this.preCloserDataSource = [this.PreCloserDetails];
          this.showSpinner = false;
        }
      });
  }
  LMS_Get_User_For_Waiver_Approval() {
    this.showSpinner = true;
    let _due =
      this.totalCalculator.totalDueAmount -
      this.totalCalculator.totalReceiveAmount;
    this.lmsService
      .LMS_Get_User_For_Waiver_Approval({
        LoginUserId: this.data.userId,
        WaiverAmount: this.PreCloserDetails.totalWaiverAmount,
        DueAmount: this.totalCalculator.totalBalance,
      })
      .subscribe((res: any) => {
        if (res != null) {
          this.wavieruserList = res;
          this.showSpinner = false;
        }
      });
  }

  getLoanRescheduleDetail() {
    //  this.showSpinner = true;
    this.lmsService
      .LMS_Get_Loan_Closer_Detail({
        Loan_Id: JSON.parse(this.LoanId),
        LoginUserId: this.data.userId,
      })
      .subscribe((res: any) => {
        if (res != null) {
          this.InterMediatAccountId = res.Item1[0].InterMediatAccountId;
          console.log("REsult of api call of get loan closer details", res);
          this.LoanAllDetail = res.Item1;
          this.LoanAllDetailNew = res.Item2;
          console.log("Loan Details first table", this.LoanAllDetail);

          if (
            this.LoanAllDetail[0].EMIType == "Daily" ||
            this.LoanAllDetail[0].EMIType == "Weekly" ||
            this.LoanAllDetail[0].EMIType == "Fortnightly" ||
            this.LoanAllDetail[0].EMIType == "ByWeekly" ||
            this.LoanAllDetail[0].EMIType == "FourthWeekly" ||
            this.LoanAllDetail[0].EMIType == "SingleEMI"
          )
            this.LoanTenureFreq = "Days";
          else this.LoanTenureFreq = "Months";

          this.MinEffectiveDate = new Date(this.LoanAllDetail[0].LoanDate);
          this.LoanCustomerList = JSON.parse(JSON.stringify(res.Item2));
          this.CustomerName = this.LoanCustomerList.find((obj: any) => {
            return obj.CustomerType == "Hirer";
          }).Customer;
          this.CustomerAddress = this.LoanCustomerList.find((obj: any) => {
            return obj.CustomerType == "Hirer";
          }).Present_Address;
          this.dataSource = new MatTableDataSource(this.LoanCustomerList);
          this.dataSource.sort = this.sort;
          this.showSpinner = false;
          this.LMS_Get_Loan_Closer_Due_Detail(null);
        }
      });
  }

  //   if (
  //     this.ApplicationDetail.EMIType == "Daily" ||
  //     this.ApplicationDetail.EMIType == "Weekly" ||
  //     this.ApplicationDetail.EMIType == "Fortnightly"
  //   )
  //     this.TenureName = "Days";
  //   else this.TenureName = "Months";
  //   this.customerData = res.Item2;

  //   this.SourceAssets = res.Item6;
  //   this.showLess_LoanDetail = true;
  // });

  onCalculateAmount() {
    let _totalDue: any = 0;
    let _totalReceived: any = 0;
    let _totalWaiver: any = 0;
    let _totalBalance: any = 0;
    let _maxWaiver: any = 0;
    let _wc: any = 0;
    this.PreCloserMethodList.forEach((obj) => {
      _totalDue = _totalDue + obj.DueAmount;
      _totalReceived = _totalReceived + obj.ReceiveAmount;
      _totalWaiver = _totalWaiver + Number(obj.WaiverAmount);
      _totalBalance = _totalBalance + Number(obj.Balance);
      obj.initialWaiverAmount = obj.WaiverAmount || 0;
      obj.lastWaiverAmount = obj.WaiverAmount || 0;
      obj.initialBalance = obj.initialBalance || Number(obj.Balance) + obj.WaiverAmount;
      if (obj.HeadId != 27 || obj.HeadId != 34) {
        _maxWaiver = _maxWaiver + Number(obj.Balance);
      }
      //const _cal = obj.DueAmount - obj.ReceiveAmount;
      const _cal = obj.Balance;
      if (obj.HeadId == 30 || obj.HeadId == 5) {
        _wc = _wc + (_cal < 0 ? 0 : _cal);
      } else {
        _wc = _wc + _cal;
      }

    });

    this.totalCalculator = {
      totalDueAmount: Number(_totalDue.toFixed(2)),
      totalReceiveAmount: Number(_totalReceived.toFixed(2)),
      totalWaiverAmount: Number(_totalWaiver.toFixed(2)),
      totalBalance: Number(_totalBalance.toFixed(2)),
      maxWaiver: Number(_maxWaiver.toFixed(2)),
    };
    this.PreCloserDetails.Waiver_Limit_Per_Amt =
      (_wc * this.PreCloserDetails.Waiver_Limit_Per) / 100;
    this.PreCloserDetails.Waiver_Limit_Per_Amt_R =
      this.PreCloserDetails.Waiver_Limit_Per_Amt <
        this.PreCloserDetails.Waiver_Limit_Amt
        ? this.PreCloserDetails.Waiver_Limit_Per_Amt
        : this.PreCloserDetails.Waiver_Limit_Amt;

    if (!this.PreCloserDetails.isFirstTimeCalculate) {
      let _tr =
        this.totalCalculator.totalBalance < 0
          ? 0
          : this.totalCalculator.totalBalance;

      if (
        !this.PreCloserDetails.CloserId &&
        (!this.PreCloserDetails.CustomerAgreed_Amount ||
          this.PreCloserDetails.CustomerAgreed_Amount <= 0)
      )
        this.PreCloserDetails.CustomerAgreed_Amount = _tr;
      this.PreCloserDetails.Prev_CustomerAgreed_Amount =
        this.PreCloserDetails.CustomerAgreed_Amount;
      this.PreCloserDetails.totalWaiverAmount =
        _tr - this.PreCloserDetails.CustomerAgreed_Amount;
      this.PreCloserDetails.isFirstTimeCalculate = true;
      if (this.PreCloserDetails.CloserId) {
        this.LMS_Get_User_For_Waiver_Approval();
        if (this.PreCloserDetails.Closer_RequestStatus == "Waiver Approved") {
          this.PreCloserDetails.totalWaiverAmount =
            this.PreCloserDetails.TotalWaiver_Approved;
        }
        if (this.PreCloserDetails.Closer_RequestStatus == "Waiver Pending") {
          this.isShowForward = true;
        } else if (
          this.PreCloserDetails.totalWaiverAmount >
          this.PreCloserDetails.Waiver_Limit_Per_Amt_R
        ) {
          this.isShowForward =
            this.PreCloserDetails.Closer_RequestStatus !== "Waiver Approved";
        }
      }
    }
    this.CalculateXirr();
  }
  resetCalculation() {
    this.PreCloserMethodList.forEach((obj) => {
      obj.WaiverAmount = 0; //obj.initialWaiverAmount;
      obj.Balance = Number((obj.initialBalance - obj.WaiverAmount).toFixed(2));
    });
    this.onCalculateAmount();
  }
  onChangeAgreeAmount(isReset: boolean = true) {
    if (
      this.PreCloserDetails.Prev_CustomerAgreed_Amount ==
      +this.PreCloserDetails.CustomerAgreed_Amount
    ) {
      return;
    }
    if (isReset) this.resetCalculation();
    let _tr =
      this.totalCalculator.totalBalance < 0
        ? this.totalCalculator.totalBalance * -1
        : this.totalCalculator.totalBalance;
    let _totalWaiverAmount =
      _tr - this.PreCloserDetails.CustomerAgreed_Amount < 0
        ? 0
        : _tr - this.PreCloserDetails.CustomerAgreed_Amount;
    if (_totalWaiverAmount > this.totalCalculator.maxWaiver) {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: `Waiver can not be greater than ${this.totalCalculator.maxWaiver}.`,
        ...this.configSuccess,
      });
      setTimeout(() => {
        this.PreCloserDetails.CustomerAgreed_Amount =
          this.PreCloserDetails.Prev_CustomerAgreed_Amount;
      });
      return;
    }
    if (this.PreCloserDetails.CustomerAgreed_Amount < 0) {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: `Deposit amount can not be less than zero.`,
        ...this.configSuccess,
      });
      setTimeout(() => {
        this.PreCloserDetails.CustomerAgreed_Amount =
          this.PreCloserDetails.Prev_CustomerAgreed_Amount;
      });
      return;
    }
    if (_tr - this.PreCloserDetails.CustomerAgreed_Amount < 0) {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: `Deposit amount can not be greater than ${this.totalCalculator.totalBalance}.`,
        ...this.configSuccess,
      });
      setTimeout(() => {
        this.PreCloserDetails.CustomerAgreed_Amount =
          this.PreCloserDetails.Prev_CustomerAgreed_Amount;
      });
      return;
    }
    this.PreCloserDetails.totalWaiverAmount = _totalWaiverAmount;
    if (this.PreCloserDetails.Closer_RequestStatus == "Waiver Pending") {
      this.isShowForward = true;
      this.LMS_Get_User_For_Waiver_Approval();
    } else {
      if (
        this.PreCloserDetails.totalWaiverAmount >
        this.PreCloserDetails.Waiver_Limit_Per_Amt_R
      ) {
        this.isShowForward =
          this.PreCloserDetails.Closer_RequestStatus !== "Waiver Approved";
        this.LMS_Get_User_For_Waiver_Approval();
      } else {
        this.isShowForward = false;
      }
    }
    this.PreCloserDetails.Prev_CustomerAgreed_Amount =
      +this.PreCloserDetails.CustomerAgreed_Amount;
    this.CalculateXirr();
  }

  onChangeWaiverAmt(event, item) {
    if (item.WaiverAmount == item.lastWaiverAmount) {
      return;
    }
    let _amount = (
      +this.PreCloserDetails.totalWaiverAmount +
      +item.lastWaiverAmount -
      +this.totalCalculator.totalWaiverAmount
    );
    if (_amount >= +item.WaiverAmount) {
      if (+item.initialBalance >= +item.WaiverAmount) {
        item.Balance = Number((+item.initialBalance - +item.WaiverAmount).toFixed(2));
        if (item.Is_Tax) {
          let _find =
            this.PreCloserMethodList.filter((obj: any) => {
              return obj.HeadId == item.HeadId;
            }) || [];
          _find.forEach((obj: any) => {
            if (!obj.Is_Tax) {
              obj.WaiverAmount = Number((
                (item.WaiverAmount * obj.Tax_Per) / 100
              ).toFixed(0));
              obj.Balance = Number(((item.Balance * obj.Tax_Per) / 100).toFixed(2));
            }
          });
        }
        this.onCalculateAmount();
      } else {
        this.snackBar.openFromComponent(SnackbarComponent, {
          data: `Wavier amount can not be greater than ${+item.Balance}.`,
          ...this.configSuccess,
        });
        setTimeout(() => {
          item.WaiverAmount = item.lastWaiverAmount;
        });
      }
    } else {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: `Wavier amount remian only ${_amount}.`,
        ...this.configSuccess,
      });
      setTimeout(() => {
        item.WaiverAmount = item.lastWaiverAmount;
      });
    }
  }

  fileChangeEvent(fileInput) {
    if (!fileInput.target.files || !fileInput.target.files.length) {
      this.PreCloserDetails.Request_Doc = "";
      this.RequestDocName = "";
      this.RequestDocBase64 = "";
      return;
    }

    let file = fileInput.target.files[0];

    let Ext = file.name.split(".").pop().toLowerCase();
    let FileSize = Math.floor(file.size / 1024); // KB

    // ✅ Size Validation
    if (FileSize > this.data.UploadMaxSize_In_KB) {
      this.PreCloserDetails.Request_Doc = "";
      this.RequestDocName = "";
      this.RequestDocBase64 = "";

      let Msg = `Upload file size should be less than or equal to ${this.data.UploadMaxSize_In_KB} KB`;
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: Msg,
        ...this.configSuccess,
      });
      return;
    }

    // ✅ Extension Validation
    if (!this.AllowExtension.includes(Ext)) {
      this.PreCloserDetails.Request_Doc = "";
      this.RequestDocName = "";
      this.RequestDocBase64 = "";

      this.snackBar.openFromComponent(SnackbarComponent, {
        data: `Invalid file type`,
        ...this.configSuccess,
      });
      return;
    }

    // ✅ Read File (works for both image + pdf)
    const fileReader = new FileReader();

    fileReader.readAsDataURL(file);

    fileReader.onload = (e) => {
      // ✅ Keep original extension instead of forcing PNG
      let timestamp = new Date().getTime();
      this.RequestDocName = `DOC_${timestamp}.${Ext}`;

      // ✅ Extract Base64 safely
      let result = fileReader.result?.toString() || "";
      this.RequestDocBase64 = result.includes(";base64,")
        ? result.split(";base64,").pop()
        : result;

      // Optional: store full data if needed
      this.PreCloserDetails.Request_Doc = this.RequestDocBase64;
    };

    fileReader.onerror = () => {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: `Error reading file`,
        ...this.configSuccess,
      });
    };
  }


  onRemoveImg() {
    this.PreCloserDetails.CloserRequestDoc = "";
    this.RequestDocName = "";
    this.RequestDocBase64 = "";
    this.PreCloserDetails.Request_Doc = "";
  }

  onCancel() {
    this.location.back();
  }

  onSaveAsDraft() {
    this.saveLoanCloser("Created");
  }
  onDeleteCloserRequest() {
    this.dialog
      .openConfirmDialog(`Are You Sure To Delete This Closer Request?`)
      .afterClosed()
      .subscribe((dialogResult) => {
        if (dialogResult == false) {
          return;
        } else {
          this.showSpinner = true;
          this.lmsService
            .LMS_Delete_Loan_Closer_Request({
              Loan_Id: JSON.parse(this.LoanId),
              CloserId: this.PreCloserDetails.CloserId,
              LoginUserId: this.data.userId,
            })
            .subscribe((res: any) => {
              if (res[0].CODE >= 0) {
                this.snackBar.openFromComponent(SnackbarComponent, {
                  data: res[0].MSG,
                  ...this.configSuccess,
                });
                this.onCancel();
              } else {
                this.snackBar.openFromComponent(SnackbarComponent, {
                  data: res[0].MSG,
                  ...this.configSuccess,
                });
              }
              this.showSpinner = false;
            });
        }
      });
  }
  onUndoCloserRequest() {
    if (this.isUndoRemark) {
      if (this.undoRemark == "") {
        this.snackBar.openFromComponent(SnackbarComponent, {
          data: `Enter undo remark.`,
          ...this.configSuccess,
        });
        return;
      }
      this.dialog
        .openConfirmDialog(`Are You Sure To Undo This Loan Closer?`)
        .afterClosed()
        .subscribe((dialogResult) => {
          if (dialogResult == false) {
            return;
          } else {
            this.showSpinner = true;
            this.lmsService
              .LMS_Loan_Closer_Request_Undo({
                Loan_Id: JSON.parse(this.LoanId),
                Remark: this.undoRemark,
                LoginUserId: this.data.userId,
              })
              .subscribe((res: any) => {
                if (res[0].CODE >= 0) {
                  this.snackBar.openFromComponent(SnackbarComponent, {
                    data: res[0].MSG,
                    ...this.configSuccess,
                  });
                  this.onCancel();
                } else {
                  this.snackBar.openFromComponent(SnackbarComponent, {
                    data: res[0].MSG,
                    ...this.configSuccess,
                  });
                }
                this.showSpinner = false;
              });
          }
        });
    } else {
      this.isUndoRemark = true;
    }
  }
  onPreClosureClose() {
    this.minDate = new Date(
      JSON.parse(sessionStorage.getItem("currentUser")).Data_Freeze.split(
        "T"
      )[0] + " 00:00:00"
    );
    if (
      new Date(this.PreCloserDetails.LoanCloser_EffectiveDate) < this.minDate
    ) {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "Data Freeze On Date ",
        ...this.configSuccess,
      });
    } else if (
      new Date(this.PreCloserDetails.LoanCloser_EffectiveDate) <
      new Date(
        this.PreCloserDetails.lastTrasactionDate
          ?.split("-")
          .reverse()
          .join("-") + " 00:00:00"
      )
    ) {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "You are not allowed to close the loan before last transaction date!!",
        ...this.configSuccess,
      });
    } else {
      this.lmsService
        .LMS_Get_Loan_Balance_Detail({
          LoanId: JSON.parse(this.LoanId),
          ToDate: new Date(
            this.PreCloserDetails.LoanCloser_EffectiveDate
          ).toLocaleDateString("fr-CA"),
        })
        .subscribe((res: any) => {
          if (res.length > 0) {
            this.dataSource = new MatTableDataSource(
              JSON.parse(JSON.stringify(res))
            );
            console.log("data source for modal api call", this.dataSource);
            this.displayedColumnsModelForLoanCloser = [
              "HeadId",
              "ChagesHead",
              "TranTypeDR",
              "TranTypeCR",
              "TranTypeTotal",
            ];
            $("#loanClosed").modal("show");
            $("#loanClosed").css("z-index", "1050");
          } else {
            var errorMsg = "";
            this.PreCloserMethodList.forEach((element: any) => {
              if (element.WaiverAmount > 0 && (element.AccountHeadId <= 0 && element.HeadId > 0)) {
                errorMsg = `Please Bind Waiver Account.`


                return;
              }
              else if (element.HeadId == 0 && element.Balance > 0) {

                errorMsg = `Other Dues must be 0 before closing the loan.`


                return;
              }
            });
            if (errorMsg != "") {
              this.snackBar.openFromComponent(SnackbarComponent, {
                data: errorMsg,
                ...this.configSuccess,
              });

            } else {
              if (
                this.totalCalculator.totalBalance <=
                this.PreCloserDetails.CustomerAgreed_Amount +
                this.totalCalculator.totalWaiverAmount
              ) {
                this.dialog
                  .openConfirmDialog(`Are you sure you want to close this loan?`)
                  .afterClosed()
                  .subscribe((dialogResult) => {
                    if (dialogResult == false) {
                      return;
                    } else {
                      this.saveLoanCloser("Closed");
                    }
                  });
              } else {
                this.snackBar.openFromComponent(SnackbarComponent, {
                  data: `Sum of customer agree amount  and waiver amount should be equal to received amount`,
                  ...this.configSuccess,
                });
              }
            }
          }

        });
    }
  }
  onWaieverApproved() {
    this.dialog
      .openConfirmDialog(`Are you sure you want to Approve?`)
      .afterClosed()
      .subscribe((dialogResult) => {
        if (dialogResult == false) {
          return;
        } else {
          this.saveLoanCloser("Waiver Approved");
        }
      });
  }

  onPrintPreClosureStatement() {
    var prtContent = document.getElementById("printData");
    var WinPrint = window.open("", "", "letf=100,top=100,width=600,height=600");
    WinPrint.document.write(prtContent.innerHTML);
    WinPrint.document.close();
    WinPrint.focus();
    WinPrint.print();
  }

  onWaieverReject() {
    this.dialog
      .openConfirmDialog(`Are you sure you want to Reject.`)
      .afterClosed()
      .subscribe((dialogResult) => {
        if (dialogResult == false) {
          return;
        } else {
          this.saveLoanCloser("Waiver Rejected");
        }
      });
  }

  onForwardToSeniorWaiverApproval() {
    if (new Date(this.PreCloserDetails.LoanCloser_EffectiveDate) <
      new Date(
        this.PreCloserDetails.lastTrasactionDate
          ?.split("-")
          .reverse()
          .join("-") + " 00:00:00"
      )
    ) {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "You are not allowed to close the loan before last transaction date!!",
        ...this.configSuccess,
      });
    } else {
      if (this.PreCloserDetails.Waiver_GivenBy != "") {
        this.saveLoanCloser("Waiver Pending");
      } else {
        this.snackBar.openFromComponent(SnackbarComponent, {
          data: `Pleasse select user to waiver.`,
          ...this.configSuccess,
        });
      }
    }
  }
  saveLoanCloser(status: any) {
    if (!this.PreCloserDetails.CloserType) {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: `Pleasse select closer type.`,
        ...this.configSuccess,
      });
      return;
    }
    if (!this.PreCloserDetails.LoanCloser_Remark) {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: `Pleasse enter remark.`,
        ...this.configSuccess,
      });
      return;
    }
    if (
      this.PreCloserDetails.Closer_RequestStatus == "Waiver Pending" &&
      !this.PreCloserDetails.LoanCloser_Remark
    ) {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: `Pleasse enter waiver remark.`,
        ...this.configSuccess,
      });
      return;
    }
    if (this.RequestDocBase64) {
      let saveObj = {
        DocName: this.RequestDocName,
        LoanId: JSON.parse(this.LoanId),
        DocData: this.RequestDocBase64,
      };
      this.lmsService.UploadLoanDoc(saveObj).subscribe((respose: any) => {
        if (respose) {
        }
      });
    }
    let _Closer: any = {
      CloserId: this.PreCloserDetails.CloserId,
      LoanId: JSON.parse(this.LoanId),
      Request_Status: status,
      EffectiveDate: new Date(
        this.PreCloserDetails.LoanCloser_EffectiveDate
      ).toLocaleDateString("fr-CA"),
      DueAmount: this.totalCalculator.totalDueAmount,
      ReceivedAmount: this.totalCalculator.totalReceiveAmount,
      BalanceAmount: this.totalCalculator.totalBalance,
      CustomerAgreedAmount: this.PreCloserDetails.CustomerAgreed_Amount,
      WaiverAmount: this.totalCalculator.totalWaiverAmount,
      WaiverLimit: this.PreCloserDetails.Waiver_Limit_Amt,
      Closer_Remark: this.PreCloserDetails.LoanCloser_Remark,
      Waiver_Remark: this.PreCloserDetails.Waiver_Remark,
      CloserDoc: this.RequestDocName || this.PreCloserDetails.CloserRequestDoc,
      LoginUserId: this.data.userId,
      WavierGivenBy: this.PreCloserDetails.Waiver_GivenBy,
      CloserType: this.PreCloserDetails.CloserType,
      Closed_Xirr: this.CalculatedXirr
    };
    let _CloserDetail: any[] = [];

    this.PreCloserMethodList.forEach((element: any) => {
      if (element.WaiverAmount > 0 && (element.AccountHeadId <= 0 && element.HeadId > 0)) {
        this.snackBar.openFromComponent(SnackbarComponent, {
          data: `Please Bind Waiver Account.`,
          ...this.configSuccess,
        });

        return;
      }
      else if (element.HeadId == 0 && element.Balance > 0) {
        this.snackBar.openFromComponent(SnackbarComponent, {
          data: `Other Dues must be 0 before closing the loan.`,
          ...this.configSuccess,
        });

        return;
      }
      else {
        _CloserDetail.push({
          HeadId: element.HeadId,
          AccountHeadId: element.AccountHeadId,
          DueAmount: element.DueAmount,
          ReceivedAmount: element.ReceiveAmount,
          WaiverAmount: element.WaiverAmount,
          IsWaiver_Eligible: element.IsWaiver_Eligible,
          Balance: element.Balance,
          IsTax: element.Tax_Per > 0 ? 1 : 0,
        });
      }
    });
    if (_CloserDetail.length == 0) {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: `Other Dues must be 0 before closing the loan.`,
        ...this.configSuccess,
      });
      this.showSpinner = false;
    }
    else {

      let _data: any = {
        Closer: _Closer,
        CloserDetail: _CloserDetail

      };
      this.showSpinner = true;
      console.log("Data to be sent for saving loan closer", _data);
      this.lmsService
        .LMS_Save_Loan_Closer_RequestNew({ JSON: JSON.stringify(_data) })
        .subscribe((res: any) => {
          if (res[0].CODE >= 0) {
            this.snackBar.openFromComponent(SnackbarComponent, {
              data: res[0].MSG,
              ...this.configSuccess,
            });
            if (status == 'Closed' && this.LoanAllDetail[0].WebsiteId) {
              //this._QuickLoanService
              //  .LoanInNeedRejected({ id: this.LoanAllDetail[0].WebsiteId, status: "Closed", application_no: this.LoanAllDetail[0].ApplicationNo })
              //  .subscribe((res: any) => {
              var request = {
                employeeId: this.data.userId.toString(),
                employeeName: this.data.FullName,
                id: this.LoanAllDetail[0].WebsiteId,
                status: 'CLOSED'
              }
              this._QuickLoanService
                .UpdateWebsiteLeads({ JSON: JSON.stringify(request) })
                .subscribe((res: any) => {
                  console.log("Result of reject loan api call", res);
                });
            }
            this.onCancel();
          } else {
            this.snackBar.openFromComponent(SnackbarComponent, {
              data: res[0].MSG,
              ...this.configSuccess,
            });
          }
          this.showSpinner = false;
        });
    }
  }

  onViewLoanStatement() {
    if (this.LoanAllDetail[0]) {
      this.loanSummary.LoanId = parseInt(this.LoanId);
      this.loanSummary.ApplicationNo = this.LoanAllDetail[0].ApplicationNo;
      this.loanSummary.LoanNo = this.LoanAllDetail[0].LoanNo;
      this.dataSharingService.LmsViewLoanStatement.next(this.loanSummary);
      $("#ViewLoanStatementPreCloserModel").modal("show");
      $("#ViewLoanStatementPreCloserModel").css("z-index", "1050");
    }
  }

  onCloseViewLoanStatement() {
    $("#ViewLoanStatementPreCloserModel").modal("hide");
  }
  onClickPrintStatement() {
    this.lmsService
      .LMS_Get_Loan_Closer_Statement({
        CloserId: this.PreCloserDetails.CloserId,
        LoginUserId: this.data.userId,
      })
      .subscribe((res: any) => {
        this.loanStatement = res;
        let _total = 0;
        this.loanStatement.Item2.forEach((obj: any) => {
          _total = _total + obj.Balance;
        });
        this.loanStatement.total = _total;
        $("#PrintLoanStatementPreCloserModel").modal("show");
        $("#PrintLoanStatementPreCloserModel").css("z-index", "1050");
      });
  }
  onClosePrintLoanStatement() {
    $("#PrintLoanStatementPreCloserModel").modal("hide");
  }
  downloadPdf() {
    var prtContent = document.getElementById("pdfPrintReport");
    //var WinPrint = window.open("", "", "letf=100,top=100,width=600,height=600");
    var WinPrint = window.open("letf=100,top=100");
    WinPrint.document.write(prtContent.innerHTML);
    WinPrint.document.close();
    WinPrint.focus();
    WinPrint.print();
  }
  onPrintCalculateAmount() {
    let _totalDue: any = 0;
    let _totalReceived: any = 0;
    let _totalWaiver: any = 0;
    let _totalBalance: any = 0;
    let _maxWaiver: any = 0;
    let _wc: any = 0;
    this.PrintCloserMethodList.forEach((obj) => {
      _totalDue = _totalDue + obj.DueAmount;
      _totalReceived = _totalReceived + obj.ReceiveAmount;
      _totalWaiver = _totalWaiver + Number(obj.WaiverAmount);
      _totalBalance = _totalBalance + obj.Balance;
      obj.initialWaiverAmount = obj.WaiverAmount || 0;
      obj.lastWaiverAmount = obj.WaiverAmount || 0;
      obj.initialBalance = obj.initialBalance || obj.Balance + obj.WaiverAmount;
      if (obj.HeadId != 27 || obj.HeadId != 34) {
        _maxWaiver = _maxWaiver + obj.Balance;
      }
      const _cal = obj.DueAmount - obj.ReceiveAmount;
      if (obj.HeadId == 30 || obj.HeadId == 5) {
        _wc = _wc + (_cal < 0 ? 0 : _cal);
      } else {
        _wc = _wc + _cal;
      }
    });

    this.printtotalCalculator = {
      totalDueAmount: Number(_totalDue),
      totalReceiveAmount: Number(_totalReceived),
      totalWaiverAmount: Number(_totalWaiver),
      totalBalance: Number(_totalBalance),
      maxWaiver: Number(_maxWaiver),
    };
  }

  onCloseDueListDetails() { }

  onCancelLoanPreCloserModel() {
    $("#loanClosed").modal("hide");
  }

  // totaltypewise(type) {
  //   if (this.dataSource != null) {
  //     let sum = 0;
  //     for (let i = 0; i < this.dataSource.filteredData.length; i++) {
  //       sum += Number(this.dataSource.filteredData[i][type]);
  //     }
  //     return sum > 0 ? sum.toFixed(2) : 0;
  //   }
  //   return 0;
  // }

  calculateChargesDR() {
    if (this.dataSource != null) {
      let sum = 0.0;
      for (let i = 0; i < this.dataSource.filteredData.length; i++) {
        sum += Number(this.dataSource.filteredData[i]["TranTypeDR"]);
      }
      return sum.toFixed(2);
    }
    return 0;
  }
  calculateChargesCR() {
    if (this.dataSource != null) {
      let sum = 0.0;
      for (let i = 0; i < this.dataSource.filteredData.length; i++) {
        sum += Number(this.dataSource.filteredData[i]["TranTypeCR"]);
      }
      return sum.toFixed(2);
    }
    return 0;
  }
  calculateChargesTotal() {
    if (this.dataSource != null) {
      let sum = 0;
      let DR = this.calculateChargesDR();
      let CR = this.calculateChargesCR();
      sum = Number(DR) - Number(CR);
      if (sum >= 0) return sum.toFixed(2).toString() + " DR";
      else return sum.toFixed(2).toString().split("-")[1] + " CR";
    }
    return 0;
  }


  //   CalculateXirr() {
  //   this.showSpinner = true;

  //   this.lmsService
  //     .GetIRRWithGivenNextEmi({
  //       LoanId: JSON.parse(this.LoanId),
  //       NextInstallmentDate: this.PreCloserDetails.LoanCloser_EffectiveDate,
  //       FinalAmount: this.PreCloserDetails.CustomerAgreed_Amount
  //     })
  //     .subscribe({
  //       next: (res: any) => {
  //         this.showSpinner = false;
  //         this.CalculatedXirr = res.IRR * 100;
  //       },
  //       error: (err: any) => {
  //         this.showSpinner = false;

  //         const errorMessage = err?.error?.error == "XIRR calculation failed" || "XIRR calculation failed";
  //         if(errorMessage){
  //           this.CalculatedXirr == "N/A";
  //         }
  //         this.snackBar.openFromComponent(SnackbarComponent, {
  //           data: errorMessage,
  //           ...this.configSuccess,
  //         });
  //       }
  //     });
  // }
  // ...existing code...
  // CalculateXirr() {
  //   this.showSpinner = true;

  //   // if waiver is approved use totalBalance as FinalAmount, otherwise use CustomerAgreed_Amount
  //   const finalAmount =
  //     this.PreCloserDetails?.Closer_RequestStatus === "Waiver Approved"
  //       ? (this.totalCalculator?.totalBalance ?? 0)
  //       : (Number(this.PreCloserDetails?.CustomerAgreed_Amount) || 0);

  //   this.lmsService
  //     .GetIRRWithGivenNextEmi({
  //       LoanId: JSON.parse(this.LoanId),
  //       NextInstallmentDate: this.PreCloserDetails.LoanCloser_EffectiveDate,
  //       FinalAmount: finalAmount,
  //     })
  //     .subscribe({
  //       next: (res: any) => {
  //         this.showSpinner = false;
  //         this.CalculatedXirr = res.IRR * 100;
  //       },
  //       error: (err: any) => {
  //         this.showSpinner = false;

  //         const errorMessage =
  //           err?.error?.error == "XIRR calculation failed" ||
  //           "XIRR calculation failed";
  //         if (errorMessage) {
  //           this.CalculatedXirr == "N/A";
  //         }
  //         this.snackBar.openFromComponent(SnackbarComponent, {
  //           data: errorMessage,
  //           ...this.configSuccess,
  //         });
  //       },
  //     });
  // }
  normalizeXirrForSave(xirr: number): number {
    return Math.abs(xirr) < 0.0001 ? 0 : xirr;
  }
  CalculateXirr() {
    if (this.PreCloserDetails.Closer_RequestStatus == "Closed") {
      this.CalculatedXirr = this.PreCloserDetails.Closed_Xirr;
    } else {


      // Use totalBalance when waiver is approved OR when net receivable is zero/negative
      // Also prefer TotalWaiver_Approved when present
      const balance = Number(this.totalCalculator?.totalBalance ?? 0);
      const approvedWaiver = Number(this.PreCloserDetails?.TotalWaiver_Approved ?? 0);
      const finalAmount =
        this.PreCloserDetails?.Closer_RequestStatus === "Waiver Approved" ||
          approvedWaiver > 0 ||
          balance <= 0
          ? balance
          : (Number(this.PreCloserDetails?.CustomerAgreed_Amount) || 0);

      this.lmsService
        .GetIRRWithGivenNextEmi({
          LoanId: JSON.parse(this.LoanId),
          NextInstallmentDate: this.PreCloserDetails.LoanCloser_EffectiveDate,
          FinalAmount: finalAmount,
        })
        .subscribe({
          next: (res: any) => {
            this.showSpinner = false;
            this.CalculatedXirr = this.normalizeXirrForSave(res.IRR * 100);
          }
          // ,
          // error: (err: any) => {
          //   this.showSpinner = false;
          //   const errorMessage =
          //     err?.error?.error == "XIRR calculation failed" ||
          //     "XIRR calculation failed";
          //   if (errorMessage) {
          //     this.CalculatedXirr = 0;
          //   }
          //   this.snackBar.openFromComponent(SnackbarComponent, {
          //     data: errorMessage,
          //     ...this.configSuccess,
          //   });
          // },
        });
    }
  }

  GetRequiredNextEmiWithTargetIRR() {
    this.showSpinner = true;
    this.lmsService
      .GetRequiredNextEmiWithTargetIRR({
        LoanId: JSON.parse(this.LoanId),
        NextInstallmentDate: this.PreCloserDetails.LoanCloser_EffectiveDate,
        TargetIRR: this.Target_IRR / 100,
        AgreementValue: this.LoanAllDetail[0].AgreementValue
      })

      .subscribe({
        next: (res: any) => {
          this.showSpinner = false;
          this.RequiredNextEmi = res.RequiredNextEmi;
        },
        error: (err: any) => {
          this.showSpinner = false;

          const errorMessage = err?.error?.error == "XIRR calculation failed" || "XIRR calculation failed";

          this.snackBar.openFromComponent(SnackbarComponent, {
            data: errorMessage,
            ...this.configSuccess,
          });
        }
      });
  }

  openXirrCalculationModal() {

    $("#XirrCalculationModal").modal("show");
    $("#XirrCalculationModal").css("z-index", "1050");
  }
  oncloseXirrCalculationModal() {
    $("#XirrCalculationModal").modal("hide");
  }

  addUncountedVoucher() {
    this.voucherModel = { Voucher: {}, Voucher_Detail: [] };
    this.Voucher_Date = this.PreCloserDetails.LoanCloser_EffectiveDate
      ? new Date(this.PreCloserDetails.LoanCloser_EffectiveDate)
      : new Date();

    this.voucherCustomerName = this.CustomerName || '';
    this.voucherLoanAcNo = this.LoanAllDetail[0]?.LoanNo || '';
    const productId =
      this.LoanAllDetail[0]?.ProductId ||
      this.LoanAllDetail[0]?.Product_Id ||
      this.LoanAllDetail[0]?.LoanProduct ||
      this.PreCloserDetails?.ProductId ||
      0;
    this.loadChargesHeadsForVoucher(productId);
    this.initializeVoucherDetail();
    this.onSearchUnaccoutedVoucher();

    $('#AddunaccountingVoucher').modal('show');
    $('#AddunaccountingVoucher').css('z-index', '1050');
  }
  onDeleteUnAccountVoucher(row) {
    this.dialog.openConfirmDialog(`Are you sure you want to remove ?`)
      .afterClosed().subscribe(dialogResult => {
        if (dialogResult == false) {
          return;
        } else {
          this.lmsService.Delete_Acc_UnAccount_Voucher({ Id: row.Id, LoginUserId: this.data.userId }).subscribe((res: any) => {
            if (res[0].CODE >= 0) {
              this.snackBar.openFromComponent(SnackbarComponent, { data: res[0].MSG, ...this.configSuccess });

              //this.initializeVoucher();
              this.voucherModel.Voucher_Detail = [];
              this.voucherModel.Voucher = {};
              this.initializeVoucherDetail();
              this.onSearchUnaccoutedVoucher();
            } else {
              this.snackBar.openFromComponent(SnackbarComponent, { data: res[0].MSG, ...this.configSuccess });
            }
          });
        }
      })
  }
  onSearchUnaccoutedVoucher() {

    this.displayedUnaccoutedColumns = [
      "Id",
      "voucher_Date",
      "CreatedBy",
      "ChagesHead",
      "Amount",
      "TransType",
      "Narration",
      "Delete"
    ];

    this.showSpinner = true;
    this.lmsService
      .Get_Acc_UnAccount_Voucher({
        LoanNo: this.voucherLoanAcNo,
        LoginUserId: this.data.userId,
        IsActive: 1
      })
      .subscribe((res: any) => {
        if (res.length > 0) {
          console.log("Result", res);

          //this.JsonData = JSON.parse(JSON.stringify(res));

          this.dataSourceUnaccouted = new MatTableDataSource(
            JSON.parse(JSON.stringify(res))
          );
          console.log("dataSourceUnaccouted", this.dataSourceUnaccouted);
          this.dataSourceUnaccouted.sort = this.sort;

          this.dataSourceUnaccouted.paginator = this.paginator;
        } else {
          this.dataSourceUnaccouted = null;
        }
      });

    this.showSpinner = false;
  }

  OnCloseVoucherModal() {
    $('#AddunaccountingVoucher').modal('hide');
  }

  initializeVoucherDetail() {
    this.voucherModel.Voucher_Detail.push({
      // Keep each voucher line self-contained so slab selection and save work row-wise.
      Loan_Id: this.LoanAllDetail[0]?.LoanNo || "",
      LoanId: JSON.parse(this.LoanId),
      ChargeHeadId: "",
      TranType: "CR",
      Amount: "",
      Type: "",
      GST_Type: "",
      Party_AccountName: "",
      HSN_Code: "",
      Slab_Name: "",
      TaxSlab1: [],
      Tax_Per: "",
      SGST: "",
      CGST: "",
      IGST: "",
      SGST_AccountId: "",
      CGST_AccountId: "",
      IGST_AccountId: "",
      CustomerId: "",
      Customer: this.CustomerName || "",
      ProductId:
        this.LoanAllDetail[0]?.ProductId ||
        this.LoanAllDetail[0]?.Product_Id ||
        this.LoanAllDetail[0]?.LoanProduct ||
        this.PreCloserDetails?.ProductId ||
        0,
      StateId: this.LoanAllDetail[1]?.StateId,
      State_Name: this.LoanAllDetail[1]?.State_Name || "",
      Branch_StateId:
        this.LoanAllDetail[0]?.Branch_StateId ||
        this.LoanAllDetail[0]?.StateId ||
        "",
      GST_No: "",
      Branch_Name: this.LoanAllDetail[0]?.Branch || "",
      GSTModel: {},
      IsGSTEnable: 0,
      ChargeHeadCategory: "",
      AccountId: "",
      Bind_Voucher: this.Bind_Voucher,
    });
  }

  loadChargesHeadsForVoucher(productId: number) {
    if (
      this.chargesHeadDropdown?.length > 0 &&
      this.chargesHeadProductIdLoaded === productId
    ) {
      return;
    }

    this.lmsService.Get_ChargesHeads_ForUnAccountVoucher({
      productId: productId || 0
    }).subscribe((res: any) => {
      const uniqueCharges = (res || []).reduce((acc: any[], current: any) => {
        const existingItem = acc.find((item) => item.Id == current.Id);
        return existingItem ? acc : acc.concat([current]);
      }, []);

      this.chargesHeadDropdown = uniqueCharges;
      this.chargesHeadProductIdLoaded = productId;
    });
  }

  isVoucherRowReady(vdData: any) {
    return !!(
      vdData &&
      vdData.TranType &&
      vdData.ChargeHeadId &&
      vdData.ChargeHeadCategory &&
      vdData.Amount
    );
  }

  onChangeChargesHead(vdData: any, i: number, selectedHeadId?: any) {
    const headId = selectedHeadId ?? vdData.ChargeHeadId;
    vdData.ChargeHeadId = headId;
    vdData.AccountId = "";
    vdData.IsGSTEnable = 0;
    vdData.TaxSlab1 = [];
    vdData.GSTModel = {};

    if (!headId) {
      vdData.ChargeHeadCategory = "";
      return;
    }

    const selectedHead = this.chargesHeadDropdown.find((ch) => ch.Id == headId);
    vdData.ChargeHeadCategory = selectedHead?.ChagesHead || vdData.ChargeHeadCategory || "";

    this.lmsService
      .Get_AccountHead_For_VoucherEntry({
        HeadId: headId,
        VoucherSubType: "Loan",
        ProductId: vdData.ProductId,
        TaxType: vdData.TranType,
        LoanNo: this.loanSummary.LoanNo
      })
      .subscribe((res: any) => {
        if (res?.Item1?.length > 0) {
          vdData.ChargeHeadCategory = res.Item1[0].AccountName;
          vdData.IsGSTEnable = res.Item1[0].IsGSTEnable;
          vdData.AccountId = res.Item1[0].AccountId;
          if (!vdData.IsGSTEnable) {
            vdData.TaxSlab1 = [];
            vdData.GSTModel = {};
          }
        } else {
          vdData.ChargeHeadCategory = selectedHead?.ChagesHead || "";
        }

        if (Number(vdData.Amount || 0) > 0) {
          this.onChangeAmount(null, vdData, i);
        }
      });
  }

  onChangeAmount(event: any, vdData: any, i: number) {
    if (event) {
      event.preventDefault();
    }

    if (!this.isVoucherRowReady(vdData) || !Number(vdData.Amount || 0)) {
      return;
    }

    if (
      !vdData.TaxSlab1?.length ||
      Number(vdData.GSTModel?.Amount || 0) !== Number(vdData.Amount || 0)
    ) {
      if ($("#TaxSlabModalWindow").hasClass("show") && this.activeVoucherRowIndex === i) {
        return;
      }
      this.activeVoucherRowIndex = i;
      console.log("mharo state", this.LoanAllDetail[1]?.StateId);
      this.taxSlabModel = {
        Slab_Tax: vdData.GSTModel?.Slab_Tax || "",
        PartyType: vdData.GSTModel?.PartyType || "Existing_Party",
        Customer: vdData.GSTModel?.Customer || vdData.Customer || this.CustomerName || "",
        Acc_GSTNo: vdData.GSTModel?.Acc_GSTNo || vdData.GST_No || "",
        StateId: vdData.GSTModel?.StateId || vdData.StateId || this.LoanAllDetailNew[0]?.StateId || "",
        State_Name: vdData.GSTModel?.State_Name || vdData.State_Name || this.LoanAllDetailNew[0]?.State_Name || "",
        HSNCode: vdData.GSTModel?.HSNCode || "",
        Amount: vdData.Amount,
        TranType: vdData.TranType,
        Charge_head: vdData.ChargeHeadCategory,
      };
      $("#TaxSlabModalWindow").modal("show");
      $("#TaxSlabModalWindow").css("z-index", "1060");
    }
  }

  saveVoucher() {
    const voucherDetails: any[] = [];

    this.voucherModel.Voucher_Detail.forEach((row: any) => {
      let Tax_Per = "";
      let SGST = 0;
      let CGST = 0;
      let IGST = 0;
      let SGST_AccountId = 0;
      let CGST_AccountId = 0;
      let IGST_AccountId = 0;

      if (row.TaxSlab1 && row.TaxSlab1.length > 0) {
        row.TaxSlab1.forEach((taxRow: any) => {
          Tax_Per = taxRow.TaxSlab_Rate;
          if (row.TaxSlab1[0].TypeGST && taxRow.TaxSlab_Type.includes("SGST")) {
            SGST = taxRow.TaxAmount;
            SGST_AccountId = taxRow.AccountId;
          }
          if (row.TaxSlab1[0].TypeGST && taxRow.TaxSlab_Type.includes("CGST")) {
            CGST = taxRow.TaxAmount;
            CGST_AccountId = taxRow.AccountId;
          }
          if (taxRow.TypeIGST) {
            IGST = taxRow.TaxAmount;
            IGST_AccountId = taxRow.AccountId;
          }
        });
      }

      voucherDetails.push(this.dataSharingService.cleanObject({
        Loan_Id: row.LoanId,
        ChargeHeadId: row.ChargeHeadId,
        AccountId: row.AccountId,
        TranType: row.TranType,
        Amount: row.Amount,
        Type: row.TaxSlab1?.length > 0 ? "Output" : "",
        GST_Type: row.TaxSlab1?.length > 0 ? row.GSTModel?.PartyType : "",
        GST_No: row.TaxSlab1?.length > 0 ? row.GSTModel?.Acc_GSTNo : "",
        Party_AccountName: row.TaxSlab1?.length > 0 ? row.GSTModel?.Customer : "",
        HSN_Code: row.TaxSlab1?.length > 0 ? row.GSTModel?.HSNCode : "",
        Slab_Name: row.TaxSlab1?.length > 0 ? row.GSTModel?.Slab_Tax : "",
        Tax_Per: Tax_Per,
        SGST: SGST,
        CGST: CGST,
        IGST: IGST,
        SGST_AccountId: SGST_AccountId,
        CGST_AccountId: CGST_AccountId,
        IGST_AccountId: IGST_AccountId,
      }));
    });

    const finalPayload = { Voucher_Detail: voucherDetails };

    this.lmsService.Acc_Save_UnAccount_Voucher({
      JSON: JSON.stringify(finalPayload),
      Narration: this.voucherModel.Voucher.Voucher_Narration,
      VoucherDate: this.Voucher_Date,
      LoginUserId: this.data.userId
    }).subscribe((res: any) => {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: res[0].MSG,
        ...this.configSuccess,
      });

      if (res[0].CODE >= 0) {
        this.OnCloseVoucherModal();
        const currentDate = this.PreCloserDetails.LoanCloser_EffectiveDate
          ? new Date(this.PreCloserDetails.LoanCloser_EffectiveDate).toLocaleDateString("fr-CA")
          : null;

        this.LMS_Get_Loan_Closer_Due_Detail(currentDate);
      }
    });

  }

  // Add a fresh voucher line from the pre-closer modal itself.
  addVoucherRow() {
    this.Bind_Voucher = this.Bind_Voucher + 1;
    this.initializeVoucherDetail();
  }

  removeVoucherRow(index: number) {
    this.voucherModel.Voucher_Detail.splice(index, 1);
  }

  closeTaxSlabModal() {
    $("#TaxSlabModalWindow").modal("hide");
    this.activeVoucherRowIndex = -1;
  }

  onPartyTypeChange() {
    if (this.taxSlabModel.PartyType == "New_Party") {
      this.taxSlabModel = {
        PartyType: this.taxSlabModel.PartyType,
        Slab_Tax: this.taxSlabModel.Slab_Tax || "",
        Customer: "",
        Acc_GSTNo: "",
        StateId: "",
        HSNCode: this.taxSlabModel.HSNCode || "",
        Amount: this.taxSlabModel.Amount,
        TranType: this.taxSlabModel.TranType,
        Charge_head: this.taxSlabModel.Charge_head,
      };
    } else {

      const stateId =
        this.taxSlabModel.StateId ||
        this.voucherModel?.Voucher_Detail?.[this.activeVoucherRowIndex]?.StateId ||
        this.LoanAllDetailNew?.[0]?.StateId ||
        "";
      const stateObj = this.stateDropdownList.find((s: any) => s.StateId == stateId);
      const stateName =
        stateObj?.State_Name ||
        this.taxSlabModel.State_Name ||
        this.voucherModel?.Voucher_Detail?.[this.activeVoucherRowIndex]?.State_Name ||
        "";
      this.taxSlabModel = {
        PartyType: this.taxSlabModel.PartyType,
        Slab_Tax: this.taxSlabModel.Slab_Tax || "",
        Customer:
          this.voucherModel?.Voucher_Detail?.[this.activeVoucherRowIndex]?.Customer ||
          this.voucherCustomerName ||
          "",
        Acc_GSTNo: this.voucherModel?.Voucher_Detail?.[this.activeVoucherRowIndex]?.GST_No || this.taxSlabModel.Acc_GSTNo || "",
        StateId: stateId,
        State_Name: stateName,
        HSNCode: this.taxSlabModel.HSNCode || "",
        Amount: this.taxSlabModel.Amount,
        TranType: this.taxSlabModel.TranType,
        Charge_head: this.taxSlabModel.Charge_head,
      };
    }
  }

  saveTaxSlabDetails() {
    if (this.activeVoucherRowIndex < 0) {
      return;
    }

    const currentVoucherRow = this.voucherModel.Voucher_Detail[this.activeVoucherRowIndex];

    this.lmsService.Get_TaxSlab_Details({ TaxSlab: this.taxSlabModel.Slab_Tax }).subscribe((res: any) => {
      let taxSlabData = [];
      const taxType = this.taxSlabModel.TranType == "DR" ? "Input" : "Output";
      const branchStateId = currentVoucherRow?.Branch_StateId;

      if (branchStateId == this.taxSlabModel.StateId) {
        taxSlabData = res.filter((item) => item.TaxType == taxType && item.IsInterState == "With in State");
      } else {
        taxSlabData = res.filter((item) => item.TaxType == taxType && item.IsInterState == "Inter state");
      }

      taxSlabData.forEach((item) => {
        item.Amount = this.taxSlabModel.Amount;
        item.TaxAmount = (Number(this.taxSlabModel.Amount) * Number(item.TaxSlab_Rate) / 100).toFixed(2);
        item.TypeGST = item.TaxSlab_Type.includes("SGST");
        item.TypeIGST = item.TaxSlab_Type.includes("IGST");
      });

      // Persist the selected slab under the same voucher row so the UI shows it just below that row.
      currentVoucherRow.TaxSlab1 = taxSlabData;
      currentVoucherRow.GSTModel = { ...this.taxSlabModel };
      this.closeTaxSlabModal();
    });
  }

  GetStateDropdown() {
    this.losService.GetStateDropdown({}).subscribe((res: any) => {
      this.stateDropdownList = res;
    });
  }

  Get_TaxSlab_Dropdown() {
    this.lmsService.Get_TaxSlab_Dropdown({}).subscribe((res: any) => {
      this.taxSlabList = (res || []).reduce((acc, current) => {
        const existingItem = acc.find((item) => item.TaxSlab_Name === current.TaxSlab_Name);
        return existingItem ? acc : acc.concat([current]);
      }, []);
    });
  }
}
